export default import.meta.ROLLDOWN_FILE_URL_4cTUm3dn6r8NbXqfsWOe8w